import React from 'react'

type MainContainerProps = {
  children?: React.ReactNode
  className?: string
}

const MainContainer: React.FC<MainContainerProps> = ({ children, className }) => {
  return (
    <main className={className ?? 'flex-auto'}>
      {children}
    </main>
  )
}

export default MainContainer
